module.exports = __webpack_public_path__ + "05_face.ce50f48b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer1/05_face.png
// module id = 0WCL
// module chunks = 0